import { render, staticRenderFns } from "./woman-item.vue?vue&type=template&id=553d8c10&"
import script from "./woman-item.vue?vue&type=script&lang=js&"
export * from "./woman-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports